// SideBySideLayout.js
import { isMobileView } from "./CommonFunctions";

const SideBySideLayout = ({ left, right,showFullScreen }) => {
   
  return (
    <div className="flex w-full h-screen overflow-hidden lg:p-3 bg-gray-soft-gradient ">
        {isMobileView() &&<div className="flex w-full h-full overflow-hidden shadow-lg">
        <div className="w-full bg-white ">
          {right}
        </div>
      </div>}
      {!isMobileView() &&<div className="flex w-full h-full  rounded-2xl overflow-hidden shadow-lg">
        {!showFullScreen &&<div className="w-[25%] border-r-2 border-gray-200 bg-white ">
          {left}
        </div>}
        <div className={`${showFullScreen ? "w-full" :"w-[75%]"} bg-white `}>
          {right}
        </div>
      </div>}
    </div>
  );
};

export default SideBySideLayout;